import { ModalDialog } from '../modalDialog.tsx';
import { ProgramNameMappings } from './programNameMappings.tsx';


interface Props {
    onClose: () => void;
}

export function ProgramNameMappingDialog({
    onClose,
}: Props) {

    return (
        <ModalDialog
            isOpen={true}
            onCancel={onClose}
        >
            <ProgramNameMappings />
        </ModalDialog>
    );
}
